// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y5Bu","col":"styles_col__1BkQP"};